
function showSpinner() {
  $('#global-spinner-wrap').fadeIn()
}

function hideSpinner() {
  $('#global-spinner-wrap').fadeOut()
}
